<template>
  <div class="principle-addition column is-one-third is-pulled-left">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deletePrinciple(principle.id)"/>
      <b-field>
          <b-input placeholder="Заголовок" v-model="principle.title" required @change="updatePrinciple(principle)"></b-input>
      </b-field>
      <b-field>
        <b-input placeholder="Текст" type="textarea" v-model="principle.description" @change="updatePrinciple(principle)" required></b-input>
      </b-field>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'Principle',
    data () {
      return {

      }
    },
    props: {
      principle: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions(['deletePrinciple', 'updatePrinciple'])
    }
  }
</script>

<style scoped>
.principle-addition {
  background: #eeeeee;
  position: relative;
  margin: 20px 0px;
}

.delete-icon {
  top: -5px;
  right: -5px;
}
</style>



// WEBPACK FOOTER //
// Principle.vue?6e992ba2